import { usePermissionsRepository } from '@Hooks/useRepository';
import { OwnUserRepository } from '@Repositories/Permissions';
import { useMutation } from '@tanstack/react-query';

export const useAcceptPrivacyPolicy = () => {
    const ownUser = usePermissionsRepository(OwnUserRepository);

    return useMutation({
        mutationFn: (version: number) => ownUser.acceptPrivacyPolicy({ version }),
    });
};
